declare global {
  interface Window {
    __ENV__?: Record<string, string>;
  }
}

export function getEnv(key: string, fallback?: string): string {
  return window.__ENV__?.[key] ?? process.env[key] ?? fallback ?? "";
}
